<template>
  <div>
    <lab-header ref="lab_header" page-name="Members"></lab-header>
    <cramb-header page-name="Members" :path="path"></cramb-header>
    <div v-if="this.isMobile === true">
      <members-mbi :memberUrl="memberUrl"></members-mbi>
    </div>
    <div v-else>
      <members-pc :memberUrl="memberUrl"></members-pc>
    </div>
    <div style="height: 100px; clear: left"></div>
    <lab-footer></lab-footer>
  </div>
</template>

<script>
import MembersPc from '../views/members/MembersPc'
import MembersMbi from '../views/members/MembersMbi'
import LabHeader from '../components/public/LabHeader'
import LabFooter from '../components/public/LabFooter'
import CrambHeader from '../components/public/CrambHeader'

export default {
  name: 'Members',
  components: {
    CrambHeader,
    MembersPc,
    MembersMbi,
    LabFooter,
    LabHeader
  },
  data () {
    return {
      msg: '',
      isMobile: false,
      path: [
        {
          name: 'Home',
          url: '/'
        },
        {
          name: 'Members',
          url: '/members'
        }
      ],
      memberUrl: {
        mainImg: '',
        PhDList: [],
        masterList: []
      }
    }
  },
  mounted () {
    if (this._isMobile()) {
      this.isMobile = true
      // this.$router.replace('/membersMbi')
    } else {
      this.isMobile = false
      // this.$router.replace('/membersPc')
    }
    this.getMemberUrl()
  },
  methods: {
    _isMobile () {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    getMemberUrl () {
      this.$axios.get('/server_api/core/members/members_info')
        .then((response) => {
          let res = response.data
          if (res.code === 0) {
            let members = res.data.rows
            for (var i = 0; i < res.data.total; i++) {
              if (members[i].bachelor === 'group') {
                this.memberUrl.mainImg = this.$getImgPath(members[i].imgPath)
              } else if (members[i].bachelor === 'PhD.') {
                members[i].imgReqUrl = this.$getImgPath(members[i].imgPath)
                this.memberUrl.PhDList.push(members[i])
              } else if (members[i].bachelor === 'Master') {
                members[i].imgReqUrl = this.$getImgPath(members[i].imgPath)
                this.memberUrl.masterList.push(members[i])
              }
            }
          } else {
            this.$message({
              message: '获取学生信息失败',
              type: 'error'
            })
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Members.vue